import { render, staticRenderFns } from "./ProofWork.vue?vue&type=template&id=50ad1094"
import script from "./ProofWork.vue?vue&type=script&lang=js"
export * from "./ProofWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports